export default "__VITE_ASSET__BFfb6a8a__"